import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContactComponent } from './contact.component';

@Injectable()
export class ContactService {
  constructor(private readonly dialog: MatDialog) {}
  open(idUsuario: number): MatDialogRef<ContactComponent, number> {
    return this.dialog.open<ContactComponent, number>(ContactComponent, {
      data: idUsuario,
    });
  }
}
